module.exports = __webpack_public_path__ + "img/error_stepper.91ada02f.svg";